import { none } from 'ramda';
import { isNilOrEmptyString } from 'ramda-extension';

import { USER_ROLES } from 'constants/general';
import { cleanse, toIsoDateFormat } from 'utils';

import { productionStatuses } from './constants';

// For this to work i expect that data that i am getting for BE belongs tu organization structure of current user
export const canUserDeleteProduction = (production, userRole) => {
	const { organisationStructure: { ppz } = {}, productionStatus, productionDocStatus } = production;

	const status = productionStatus || productionDocStatus || {};
	const isOpen =
		productionStatuses[status] === productionStatuses.VALID ||
		productionStatuses[status] === productionStatuses.NEW;

	if (userRole === USER_ROLES.PPZ) {
		return isOpen;
	}

	// Seller can only delete productions of its sub sellers (ppz)
	if (userRole === USER_ROLES.SELLER) {
		if (ppz) {
			return true;
		} else {
			return isOpen;
		}
	}

	return true;
};

export const validityCheckRequestBodyFactory = (formData, userRole) => {
	return cleanse({
		orgStruct: {
			channelId: formData.channel,
			regionId: formData.region,
			agencyIds: [formData.agency],
			manager: formData.manager,
			seller: formData.seller,
			ppz: formData.ppz,
		},
		policyNo: formData.policyNumber,
		scanned: isNilOrEmptyString(formData.scan) ? undefined : Boolean(formData.scan),
		reportedDateFrom: toIsoDateFormat(formData.reportDateFrom),
		reportedDateTo: toIsoDateFormat(formData.reportDateTo),
		userRole,
		withoutPpz: !formData.withoutPpz,
		documentTypeId: formData.documentType,
	});
};

export const getProductionStatusProps = (status) => {
	switch (productionStatuses[status]) {
		case productionStatuses.NEW:
			return { name: 'exclamationMark', style: { fontSize: '20px', color: '#FF5252' } };
		case productionStatuses.VALID:
			return { name: 'checkSquare', style: { fontSize: '20px', color: '#4CAF50' } };
		case productionStatuses.CLOSED:
			return { name: 'locked', style: { fontSize: '20px', color: '#4872A2' } };
	}
};

export const getHasOrgStructureFilledToSeller = ({ channelId, regionId, agencyId, managerLogin, sellerLogin }) =>
	none(isNilOrEmptyString)([channelId, regionId, agencyId, managerLogin, sellerLogin]);
